export function onDOMReady(callback: () => void): void {
  if (document.readyState === 'complete') {
    setTimeout(() => callback(), 1);
  } else {
    document.addEventListener('DOMContentLoaded', () => callback(), false);
  }
}



// WEBPACK FOOTER //
// ./src/utils/ready.ts